import { c as _c } from "react/compiler-runtime";
import { ExternalLinks } from "@components/external-links";
import { Alert } from "@flat-ui";
import { Box } from "@mui-wrapper";
const appName = "Sphere XG/HoloBuilder Site Documentation";

/** Warning that informs customers that the Sphere XG app might not be installed in their Procore account */
export function ConnectDialogProcoreHint() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ExternalLinks text={appName} link="procoreAppStore" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div>We were unable to access the projects in your selected Procore company. It may be because the Sphere XG app is not installed in your Procore account.{" Look for the app named "}{t0}{" in the App Marketplace. "}<ExternalLinks text="See this article" link="procoreAppStoreArticle" />{" to learn how to install it."}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Alert title="Sphere XG App might not be installed in your Procore account" variant="warning" isCollapsible={true} description={<>{t1}<Box sx={{
        mt: 1
      }}><ExternalLinks text="Learn more" link="sphereXGProcoreIntegration" />{" about the Procore integration with Sphere XG."}</Box></>} sx={{
      mb: "8px"
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}